export const schemaKeys = ['schemas', 'links', 'facets', 'motifs']
const copy = (value) => JSON.parse(JSON.stringify(value))
const ordered = (value) =>
  Array.isArray(value)
    ? value.map(ordered)
    : value && typeof value === 'object'
      ? Object.fromEntries(
          Object.keys(value)
            .sort()
            .map((key) => [key, ordered(value[key])]),
        )
      : value
export const equal = (a, b) => JSON.stringify(ordered(a)) === JSON.stringify(ordered(b))
export const sameContent = (a, b) =>
  !!a && !!b && ['document', ...schemaKeys].every((key) => equal(a[key], b[key]))

// Rebase only schema edits. Concurrent graph/annotation changes need an explicit
// resolution; they must never overwrite a newer analysis or resurrect a reset graph.
export function mergeSchemaDraft(base, draft, latest) {
  if (!base || !equal(base.document, draft.document)) return null
  const merged = copy(latest)
  for (const key of schemaKeys) {
    const before = new Map(base[key].map((item) => [item.id, item]))
    const local = new Map(draft[key].map((item) => [item.id, item]))
    const remote = new Map(merged[key].map((item) => [item.id, item]))
    for (const id of before.keys()) if (!local.has(id)) remote.delete(id)
    for (const [id, item] of local) {
      const original = before.get(id)
      if (!original) remote.set(id, copy(item))
      else if (!equal(original, item)) {
        const updated = { ...(remote.get(id) || original) }
        for (const field of new Set([...Object.keys(original), ...Object.keys(item)])) {
          if (equal(original[field], item[field])) continue
          if (field in item) updated[field] = copy(item[field])
          else delete updated[field]
        }
        remote.set(id, updated)
      }
    }
    merged[key] = [...remote.values()]
  }
  return merged
}
